<template>
  <v-card elevation="1" class="mt-0 py-lg-10" style="margin: 0 !important">
    <div
      v-if="showAlert"
      style="
        position: fixed;
        top: 10%;
        width: 50%;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: #2096f3;
        color: white;

        padding: 15px 20px;
        border-radius: 5px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        transition: opacity 0.5s ease, top 0.5s ease;
      "
    >
      <div class="d-flex align-center" style="width: 100%">
        <svg
          width="36px"
          height="36px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          color="#ffffff"
          stroke-width="1.5"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75ZM12.5675 8.00075C12.8446 7.69287 12.8196 7.21865 12.5117 6.94156C12.2038 6.66446 11.7296 6.68942 11.4525 6.99731L11.4425 7.00842C11.1654 7.3163 11.1904 7.79052 11.4983 8.06761C11.8062 8.34471 12.2804 8.31975 12.5575 8.01186L12.5675 8.00075Z"
            fill="#ffffff"
          ></path>
        </svg>
        <div style="margin-left: 24px">
          <div style="text-align: left; font-weight: 600">
            <p
              v-for="(line, index) in totalDataAlert"
              :key="index"
              style="margin-bottom: 0"
            >
              {{ line }}
            </p>
          </div>
          <div v-if="missingMessages.length > 0" class="mt-2">
            <p v-for="(message, index) in missingMessages" :key="index">
              {{ message }}
            </p>
          </div>
        </div>

        <v-btn
          style="
            text-transform: unset !important;
            background-color: white;
            padding: 1vh 1vh;
            border-radius: 30px !important;
            font-weight: bolder;
            font-size: medium;
            margin-left: 2%;
          "
          elevation="0"
          class="darken-1"
          type="submit"
          color="primary"
          @click="showAlert = false"
          >{{ $t('buttons.ok') }}</v-btn
        >
      </div>
    </div>
    <v-dialog v-model="addChartEntryModal" @input="resetModal" max-width="800">
      <v-card class="popup-card" elevation="1">
        <v-card-title class="popupHeadline" style="font-size: 24px">
          <div class="text-sm-center popupHeadline" style="width: 100%">
            {{ $t('labels.addNew') }}
          </div>
        </v-card-title>

        <v-divider class="mb-4" />

        <ValidationObserver
          ref="addChartEntryObserver"
          v-slot="{ handleSubmit }"
        >
          <form autocomplete="off" @submit.prevent="handleSubmit(add)">
            <div style="position: absolute; top: 12px; right: 10px">
              <v-btn
                @click="handleDownload(1)"
                class="rounded-circle mr-2"
                style="
                  min-width: 1px;
                  min-height: 1px;
                  width: 36px;
                  height: 36px;
                  background-color: #0177d4;
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      small
                      color="white"
                      style="font-size: 20px"
                      v-on="on"
                    >
                      mdi-file-check-outline
                    </v-icon>
                  </template>
                  <span>{{ $t('buttons.samplePriceExcelDownload') }}</span>
                </v-tooltip>
              </v-btn>
              <v-btn
                @click="handleDownload(2)"
                class="rounded-circle mr-2"
                style="
                  min-width: 1px;
                  min-height: 1px;
                  width: 36px;
                  height: 36px;
                  background-color: #0177d4;
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      small
                      color="white"
                      style="font-size: 20px"
                      v-on="on"
                    >
                      mdi-file-check-outline
                    </v-icon>
                  </template>
                  <span>{{ $t('buttons.sampleRegionExcelDownload') }}</span>
                </v-tooltip>
              </v-btn>
            </div>

            <v-card-text class="pb-0">
              <v-row>
                <v-col cols="6" sm="3" md="3" lg="3" xl="3">
                  <input
                    type="radio"
                    id="one"
                    value="1"
                    style="
                      width: 20px;
                      height: 20px;
                      accent-color: var(--mainColor);
                      margin-right: 10px;
                    "
                    v-model="form.exportImportType"
                  />
                  <label
                    style="
                      display: inline-block;
                      padding: 5px 10px;
                      border-radius: 15px;
                      background-color: var(--mainColor);
                      color: white;
                      cursor: pointer;
                    "
                    class="custom-label-form-element"
                    for="one"
                    >{{ $t('labels.export') }}</label
                  >
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3" xl="3">
                  <input
                    type="radio"
                    id="two"
                    value="0"
                    style="
                      width: 20px;
                      height: 20px;
                      accent-color: var(--mainColor);
                      margin-right: 10px;
                    "
                    v-model="form.exportImportType"
                  />
                  <label
                    style="
                      display: inline-block;
                      padding: 5px 10px;
                      border-radius: 15px;

                      background-color: var(--mainColor);
                      color: white;
                      cursor: pointer;
                    "
                    class="custom-label-form-element"
                    for="one"
                    >{{ $t('labels.import') }}</label
                  >
                </v-col>

                <FormElement
                  key="ENTRY_NAME"
                  :vertical="true"
                  v-model="form.name"
                  :validationLabel="$t('labels.customerList')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :formType="{
                    name: 'text',
                  }"
                  :placeholder="$t('labels.customerList')"
                />
                <FormElement
                  key="ENTRY_CARGO"
                  :vertical="true"
                  v-model="form.cargo"
                  :validationLabel="$t('labels.priceListName')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :formType="{
                    name: 'text',
                  }"
                  :placeholder="$t('labels.priceListName')"
                />

                <FormElement
                  key="ENTRY_COUNTRY"
                  :vertical="true"
                  v-model="form.country"
                  :validationLabel="$t('labels.country')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :formType="{
                    name: 'multipleSelect',
                    items: {
                      data: countries,
                      value: 'Id',
                      text: 'Name',
                    },
                  }"
                  :placeholder="$t('labels.country')"
                />

                <FormElement
                  key="ENTRY_CURRENCY"
                  :vertical="true"
                  v-model="form.currency"
                  :validationLabel="$t('labels.currency')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :formType="{
                    name: 'multipleSelect',
                    items: {
                      data: currencies,
                      value: 'Code',
                      text: 'Code',
                    },
                  }"
                  :placeholder="$t('labels.currency')"
                />

                <FormElement
                  key="ENTRY_PORTAL_TYPE"
                  :vertical="true"
                  v-model="form.IntegrationLogistic"
                  :validationLabel="$t('titles.subsupplier')"
                  :topLabel="true"
                  rules="required"
                  :labelShown="false"
                  :onChange="portalTypeChanged"
                  :lg="6"
                  :formType="{
                    name: 'multipleSelect',
                    items: {
                      data: portalTypes,
                      value: 'LogisticType',
                      text: 'LogisticName',
                    },
                  }"
                  :placeholder="$t('titles.subsupplier')"
                />

                <FormElement
                  key="ENTRY_PORTAL_TYPE_ID"
                  :vertical="true"
                  v-model="form.IntegrationLogisticId"
                  :validationLabel="$t('labels.accounts')"
                  :topLabel="true"
                  rules="required"
                  :labelShown="false"
                  :lg="6"
                  :formType="{
                    name: 'multipleSelect',
                    items: {
                      data: accounts,
                      value: 'Id',
                      text: 'Name',
                    },
                  }"
                  :placeholder="$t('labels.accounts')"
                />

                <FormElement
                  key="ENTRY_INTEGRATION_SERVICE"
                  :vertical="true"
                  v-model="form.IntegrationService"
                  :validationLabel="$t('titles.integrationService')"
                  rules="required"
                  :active="form.IntegrationLogistic != null"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :formType="{
                    name: 'multipleSelect',
                    items: {
                      data: integrationServices,
                      value: 'key',
                      text: 'value',
                    },
                  }"
                  :placeholder="$t('titles.integrationService')"
                />

                <FormElement
                  key="ENTRY_EXPIRY_DATE_START"
                  v-model="form.ValidityStartDate"
                  :validationLabel="$t('labels.expiryDateStart')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :formType="{
                    name: 'date',
                    dateMode: 'date',
                  }"
                  :placeholder="$t('labels.expiryDateStart')"
                />
                <FormElement
                  key="ENTRY_EXPIRY_DATE_END"
                  v-model="form.ValidityEndDate"
                  :validationLabel="$t('labels.expiryDateEnd')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :formType="{
                    name: 'date',
                    dateMode: 'date',
                  }"
                  :placeholder="$t('labels.expiryDateEnd')"
                />
                <FormElement
                  key="ENTRY_REFERENCE_NUMBER"
                  v-model="form.optionalReferenceID"
                  :validationLabel="$t('labels.optionalReferenceID')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :formType="{
                    name: 'text',
                  }"
                  :placeholder="$t('labels.optionalReferenceID')"
                />
                <FormElement
                  key="ENTRY_PORTAL_USERS"
                  v-model="form.portalUserIds"
                  :labelShown="false"
                  :formType="{
                    name: 'checkTable',
                    unselectedItems: portalUsers,
                    selectedItems: form.portalUserIds,
                  }"
                />

                <FormElement
                  key="ENTRY_FSC_GROUP"
                  :vertical="true"
                  v-model="form.fscGroupId"
                  :validationLabel="$t('navigationDrawerMenu.fscGroups')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :classes="'mt-6'"
                  :formType="{
                    name: 'multipleSelect',
                    items: {
                      data: fscGroups,
                      value: 'Id',
                      text: 'GroupName',
                    },
                  }"
                  :placeholder="$t('navigationDrawerMenu.fscGroups')"
                />

                <FormElement
                  key="ENTRY_PRICES"
                  :vertical="true"
                  v-model="form.pricesFile"
                  :validationLabel="$t('labels.price')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :fileStyling="false"
                  :classes="'mt-6'"
                  :formType="{
                    name: 'file',
                    type: '',
                    data: {
                      accept:
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
                    },
                  }"
                  :placeholder="$t('labels.price')"
                />
                <FormElement
                  key="ENTRY_REGIONS"
                  :vertical="true"
                  v-model="form.regionsFile"
                  :validationLabel="$t('labels.region')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :fileStyling="false"
                  :formType="{
                    name: 'file',
                    type: '',
                    data: {
                      accept:
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
                    },
                  }"
                  :placeholder="$t('labels.region')"
                />
                <FormElement
                v-if="isSupplier"
                  key="ENTRY_COSTS"
                  :vertical="true"
                  v-model="form.costsFile"
                  :validationLabel="$t('labels.costs')"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :fileStyling="false"
                  :formType="{
                    name: 'file',
                    type: '',
                    data: {
                      accept:
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
                    },
                  }"
                  :placeholder="$t('labels.costs')"
                />
              </v-row>
            </v-card-text>
            <v-card-actions class="d-flex justify-center pb-4">
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: #0077d5;
                  padding: 2vh 2vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                type="submit"
                :loading="$store.state.loadingStatus"
                >{{ $t('buttons.add') }}</v-btn
              >
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: var(--red);
                  padding: 2vh 2vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                @click="resetModal"
                >{{ $t('buttons.cancel') }}</v-btn
              >
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <v-card-title style="color: var(--darkBlue)">
      <v-row>
        <v-col class="text-lg-left text-center" lg="3" cols="12">
          <h5>{{ $t('navigationDrawerMenu.expressPriceList') }}</h5>
        </v-col>
      </v-row>

      <v-icon
        v-if="this.isSupplier"
        small
        class="mr-6"
        style="font-size: 32px"
        @click="addChartEntryModal = true"
      >
        mdi-plus-box-outline
      </v-icon>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-row class="mt-2" align="start">
        <FormElement
          v-model="listName"
          :validationLabel="$t('labels.listName')"
          :formLabel="$t('labels.listName')"
          @input="getSearchDebounced"
          :formType="{
            name: 'text',
            dense: true,
            appendIcon: 'mdi-magnify',
            appendClick: () => {
              getSearchDebounced();
            },
          }"
          :labelShown="false"
          :cols="4"
          :sm="3"
          :md="3"
          :lg="3"
          :xl="3"
          :topLabel="true"
          :hideDetails="true"
          :placeholder="$t('labels.listName')"
          :classes="'pb-2 pb-sm-0'"
        />

        <FormElement
          v-for="element in filterFormItems"
          :key="element.key.parent + '_' + element.key.child"
          :vertical="element.vertical"
          v-model="$data[element.key.parent][element.key.child]"
          :validationLabel="$t(element.validationLabel)"
          :rules="element.rules"
          :formLabel="$t(element.formLabel)"
          :topLabel="element.topLabel"
          :labelShown="element.labelShown"
          :onChange="element.onChange"
          :md="element.md"
          :cols="element.cols"
          :sm="element.sm"
          :lg="element.lg"
          :xl="element.xl"
          :formType="element.formType"
          :placeholder="$t(element.placeholder)"
        />
      </v-row>
    </v-card-text>
    <v-data-table
      :headers="chartEntryHeaders"
      :items="items"
      hide-default-footer
      :loading="$store.state.loadingStatus"
      :options="{
        itemsPerPage: itemsPerPage,
      }"
      :item-key="'Id'"
      :no-data-text="$t('messages.noData')"
    >
      <template v-slot:footer>
        <div class="d-flex justify-center mt-8">
          <v-row justify="space-between">
            <v-col md="2"></v-col>
            <v-col md="8" class="ml-md-auto">
              <v-pagination
                v-if="pageLength > 0"
                class="my-4"
                @input="onPageChange"
                v-model="page"
                :length="pageLength"
                :total-visible="10"
                circle
              ></v-pagination>
            </v-col>
            <v-col md="2" class="d-flex justify-center items-center pt-8 pr-6">
              <v-select
                v-model="itemsPerPage"
                :items="perPageValues"
                :label="$t('labels.selectItemsPerPage')"
                item-value="value"
                item-text="name"
                outlined
                hide-details
                dense
                @change="changeItemsPerPage"
                rounded
              >
              </v-select>
            </v-col>
          </v-row>
        </div>
      </template>
      <!-- eslint-disable -->
      <template v-slot:item.ExportImportType="{ item }">
        <v-chip
          v-if="item.ExportImportType == 0"
          style="font-weight: 600"
          class="ma-2"
          small
          color="#c5f4db"
          text-color="#2b3838"
        >
          {{ $t('labels.import') }}
        </v-chip>
        <v-chip
          v-if="item.ExportImportType == 1"
          style="font-weight: 600"
          class="ma-2"
          small
          color="#c5f4db"
          text-color="#2b3838"
        >
          {{ $t('labels.export') }}
        </v-chip>
      </template>
      <template v-slot:no-data>
        <div class="my-10 d-flex flex-column align-center">
          <h4>{{ $t('messages.noData') }}</h4>
        </div>
      </template>
      <!-- eslint-disable -->

      <template v-slot:item.isActive="{ item }">
        <v-chip
          class="ma-2"
          small
          text-color="white"
          :color="
            item.PriceListStatus === 0
              ? 'green'
              : item.PriceListStatus === 1
              ? 'red'
              : '#B2B2B2'
          "
        >
          {{
            $t(
              'labels.' +
                (item.PriceListStatus === 0
                  ? 'isActive'
                  : item.PriceListStatus === 1
                  ? 'tooltipPassive'
                  : 'expired')
            )
          }}
        </v-chip>
      </template>
      <template v-slot:item.ValidityStartDate="{ item }">
        {{ convertToLocal(item.ValidityStartDate) }}
      </template>
      <template v-slot:item.ValidityEndDate="{ item }">
        {{ convertToLocal(item.ValidityEndDate) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-start">
          <v-tooltip v-if="$store.state.Type !== 'Customer'" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                color="red"
                class="mr-1"
                style="font-size: 20px"
                v-bind="attrs"
                v-on="on"
                @click="
                  deletePriceList(item.Id)
                "
              >
                mdi-trash-can
              </v-icon>
            </template>
            <span>{{ $t('buttons.goToDetails') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                color="#29B7B7"
                class="mr-1"
                style="font-size: 20px"
                v-bind="attrs"
                v-on="on"
                @click="
                  $router.push({ name: 'viewPriceList', params: { item } })
                "
              >
                mdi-arrow-right
              </v-icon>
            </template>
            <span>{{ $t('buttons.goToDetails') }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <ConfirmationModal
      :title="$t('labels.warning')"
      :message="$t('description.deleteModalDescription')"
      :confirm="confirmDeletePriceList"
      ref="confirmationModal"
      v-model="deleteConfirmationModal"
    />
  </v-card>
</template>
<script>
import ExpressCargoServices from '../services/ExpressCargoServices';
import IntegrationService from '../services/IntegrationService';
import PortalService from '../services/PortalService';
import AdditionalCostsServices from '../services/AdditionalCostsServices';
import {
  ITEMS_PER_PAGE_OPTIONS,
  getCountries,
  getCurrencyTypes,
  logisticsTypes,
} from '../utils/constants';
import FormElement from '../components/FormElement.vue';
import formatDate from '../utils/formatDate';
import ConfirmationModal from '../components/General/ConfirmationModal.vue';

export default {
  data() {
    return {
      totalDataAlert: [],
      showAlert: false,
      missingMessages: [],

      addChartEntryModal: false,
      regionFile: null,
      priceFile: null,
      currencies: [],
      fscGroups: [],
      portalTypes: [],
      portalUsers: [],
      integrationServices: [],
      integrationPackages: [],
      countries: [],
      chartEntryHeaders: [],
      items: [],
      accounts: [],

      // States
      itemsPerPage: 10,
      page: 1,
      totalItems: 0,
      perPageValues: [
        {
          name: '5',
          value: 5,
        },
        {
          name: '10',
          value: 10,
        },
        {
          name: '15',
          value: 15,
        },
        {
          name: '30',
          value: 30,
        },
        {
          name: '50',
          value: 50,
        },
        {
          name: '100',
          value: 100,
        },
        {
          name: this.$t('labels.All'),
          value: 9999,
        },
      ],
      addChartEntryModal: false,
      form: {
        name: '',
        cargo: '',
        country: '',
        currency: '',
        fscGroupId: null,
        regionsFile: null,
        pricesFile: null,
        exportImportType: 1,
        expiryDate: new Date().toISOString().slice(0, 10),
        portalUserIds: [],
        IntegrationLogistic: null,
        IntegrationLogisticId: null,
        IntegrationService: null,
        portalUserIds: [],
      },

      isSupplier: false,

      filters: {
        searchText: '',
        subsupplier: null,
        exportImportType: null,
        priceListStatus: null,
      },
      listName: '',
      exportImportTypes: [
        {
          Value: 0,
          Name: this.$t('labels.import'),
        },
        {
          Value: 1,
          Name: this.$t('labels.export'),
        },
      ],
      deleteConfirmationModal: false,
      priceListIdToDelete: null,
    };
  },
  components: { FormElement, ConfirmationModal },
  mounted() {
    this.itemsPerPageOptions = ITEMS_PER_PAGE_OPTIONS;

    this.isSupplier =
      this.$store.state.Type === 'Supplier' ||
      this.$store.state.Type === 'PendingSupplier';

    this.setup();
  },
  watch: {
    deleteConfirmationModal(newValue){
      if(!newValue){
        this.deleteConfirmationModal = false;
        this.priceListIdToDelete = null;
      }
    }
  },
  computed: {
    filterFormItems() {
      const callback = this.getHistory;

      return [
        {
          key: {
            parent: 'filters',
            child: 'searchText',
          },
          cols: 12,
          sm: 12,
          md: 3,
          lg: 3,
          xl: 3,

          validationLabel: 'labels.customer',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            dense: true,
            appendIcon: 'mdi-magnify',
            appendClick: callback,
            items: {
              data: this.portalUsers,
              disableAutoSelection: true,
              value: 'Id',
              text: 'CompanyName',
            },
          },
          onChange: () => {
            callback();
          },
          placeholder: 'labels.customer',
        },
        {
          key: {
            parent: 'filters',
            child: 'subsupplier',
          },
          cols: 12,
          sm: 12,
          md: 2,
          lg: 2,
          xl: 2,
          validationLabel: 'titles.subsupplier',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            dense: true,
            appendIcon: 'mdi-magnify',
            appendClick: callback,
            items: {
              data: logisticsTypes,
              disableAutoSelection: true,
              value: 'Value',
              text: 'Name',
            },
          },
          onChange: () => {
            callback();
          },
          placeholder: 'titles.subsupplier',
        },
        {
          key: {
            parent: 'filters',
            child: 'exportImportType',
          },
          cols: 12,
          sm: 12,
          md: 2,
          lg: 2,
          xl: 2,
          validationLabel: 'labels.exportImportType',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            dense: true,
            appendIcon: 'mdi-magnify',
            appendClick: callback,
            items: {
              data: this.exportImportTypes,
              disableAutoSelection: true,
              value: 'Value',
              text: 'Name',
            },
          },
          onChange: () => {
            callback();
          },
          placeholder: 'labels.exportImportType',
        },
        {
          key: {
            parent: 'filters',
            child: 'priceListStatus',
          },
          cols: 12,
          sm: 12,
          md: 2,
          lg: 2,
          xl: 2,

          validationLabel: 'labels.status',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            dense: true,
            appendIcon: 'mdi-magnify',
            appendClick: callback,
            items: {
              data: this.$priceListStatuses,
              disableAutoSelection: true,
              value: 'value',
              text: 'name',
            },
          },
          onChange: () => {
            callback();
          },
          placeholder: 'labels.status',
        },
      ];
    },
    pageLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  methods: {
    deletePriceList(id) {
      if (!id) return;

      this.priceListIdToDelete = id;
      this.deleteConfirmationModal = true;
    },
    confirmDeletePriceList() {
      if (!this.priceListIdToDelete) return;
      this.$store.state.loadingStatus = true;
      ExpressCargoServices.deletePriceList({ Id: this.priceListIdToDelete })
        .then((response) => {
          window.showSuccess(this.$t('messages.defaultSuccess'));
          this.getHistory();
        })
        .catch(window.showError)
        .finally(() => this.$store.state.loadingStatus = false );
    },
    getSearchDebounced() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.getHistory();
        console.log('search');
      }, 300);
    },
    handleDownload(option) {
      const downloadUrl1 =
        'https://algonder.s3.amazonaws.com/Documents/30.05.2024%2009:45:44Express-Fiyat-Listesi.xlsx?AWSAccessKeyId=AKIA5TWV25RSSAFBF64U&Expires=1748587545&Signature=I1JbaCrZHbimM%2BFN9Pa5rTfWYo0%3D';
      const downloadUrl2 =
        'https://algonder.s3.amazonaws.com/Documents/6/25/2024%2011:33:54%20AMExpress-B%C3%B6lge-Listesi.xlsx?AWSAccessKeyId=AKIA5TWV25RSSAFBF64U&Expires=1750840434&Signature=XOJ0AlqfBVtghPrjcdTxT8PpHu0%3D';

      const downloadUrl3 =
        'https://algonder.s3.amazonaws.com/Documents/19.06.2024%2020:23:10Ornek_Uzak_Bolge.xlsx?AWSAccessKeyId=AKIA5TWV25RSSAFBF64U&Expires=1750353791&Signature=1zQx1FRVntvbW8yUev23dJnakg4%3D';

      if (option === 1) {
        window.open(downloadUrl1, '_blank');
      } else if (option === 2) {
        window.open(downloadUrl2, '_blank');
      } else if (option === 3) {
        window.open(downloadUrl3, '_blank');
      }
    },
    uploadFile(file) {
      this.$store.state.loadingStatus = true;
      const formData = new FormData();
      formData.append('File', file);
      const service = this.isRegion
        ? ExpressCargoServices.updateRegionExcel
        : ExpressCargoServices.updatePriceExcel;

      service(formData)
        .then((response) => {
          console.log('Excel => ', response);
        })
        .catch(this.onServiceError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    add() {
      this.$store.state.loadingStatus = true;
      const formData = new FormData();
      formData.append('ValidityStartDate', this.form.ValidityStartDate);
      formData.append('ValidityEndDate', this.form.ValidityEndDate);
      formData.append('ListName', this.form.name);
      formData.append('CargoName', this.form.cargo);
      formData.append('OriginCountryId', this.form.country);
      formData.append('CurrencyCode', this.form.currency);
      formData.append('FscGroupId', this.form.fscGroupId);
      formData.append('Prices', this.form.pricesFile);
      formData.append('Regions', this.form.regionsFile);
      
      if(this.isSupplier && this.form.costsFile){
        formData.append('Costs', this.form.costsFile);
      }

      if (this.form.portalUserIds && this.form.portalUserIds.length > 0) {
        this.form.portalUserIds.forEach((element) => {
          formData.append('PortalCompanyIds', element);
        });
      }
      formData.append('IntegrationLogistic', this.form.IntegrationLogistic);
      formData.append('IntegrationLogisticId', this.form.IntegrationLogisticId);
      formData.append('IntegrationService', this.form.IntegrationService);
      formData.append('ExportImportType', Number(this.form.exportImportType));

      formData.append('OptionalReferansId', this.form.optionalReferenceID);

      ExpressCargoServices.add(formData)
        .then((response) => {
          window.showSuccess(this.$t('messages.successfulAddExpress'));
          this.form = {};
          this.addChartEntryModal = false;
          this.getHistory();
          this.resetModal();

          const {
            PriceExcelNotInclude,
            RegionExcelNotInclude,
            TotalCountries,
            TotalRegions,
          } = response.data.Result;

          console.log('Response Data >>', response.data.Result);

          this.totalDataAlert = [
            this.$t('labels.totalCountries', {
              value: TotalCountries,
            }),
            this.$t('labels.totalRegions', {
              value: TotalRegions,
            }),
          ];

          // Collect missing Excel messages
          let missingMessages = [];

          if (PriceExcelNotInclude.length > 0) {
            missingMessages.push(
              this.$t('labels.missingPriceExcel', {
                value: PriceExcelNotInclude.join(', '),
              })
            );
          }

          if (RegionExcelNotInclude.length > 0) {
            missingMessages.push(
              this.$t('labels.missingRegionExcel', {
                value: RegionExcelNotInclude.join(', '),
              })
            );
          }

          this.missingMessages = missingMessages;

          this.showAlert = true;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Format the date and returns it as a string.
     * @param {Date} date
     * @returns {string}
     */
    getFormattedDate(date) {
      return formatDate(date, '/');
    },

    changeItemsPerPage() {
      this.page = 1;
      this.getHistory();
    },

    /**
     * Trigger when page changed.
     */
    onPageChange() {
      this.getHistory();
    },

    async setup() {
      this.currencies = await getCurrencyTypes();
      this.countries = await getCountries();
      this.getFscGroups();
      this.getHistory();
      this.getCompanyLogistics();
      this.getPortalUsers();
      this.chartEntryHeaders = [
        {
          text: this.$t('titles.subsupplier'),
          value: 'IntegrationLogistic',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell', 'bold-cell'],
          align: 'center',
        },
        {
          text: this.$t('labels.direction'),
          value: 'ExportImportType',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell', 'bold-cell'],
          align: 'center',
        },
        {
          text: this.$t('title.tableHeaderCreateDate'),
          value: 'CreatedAt',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell'],
          align: 'center',
        },
        {
          text: this.$t('labels.currency'),
          value: 'CurrencyCode',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell'],
          align: 'center',
        },
        {
          text: this.$t('labels.expiryDateStart'),
          value: 'ValidityStartDate',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell'],
          align: 'center',
        },
        {
          text: this.$t('labels.expiryDateEnd'),
          value: 'ValidityEndDate',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell'],
          align: 'center',
        },
        {
          text: this.$t('labels.status'),
          value: 'isActive',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell'],
          align: 'center',
        },
        {
          text: this.$t('labels.tableActions'),
          value: 'actions',
          sortable: false,
          groupable: false,
        },
      ];

      if (this.isSupplier) {
        this.chartEntryHeaders.unshift({
          text: this.$t('labels.priceListName'),
          value: 'CargoName',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell', 'bold-cell'],
          align: 'center',
        });
      } else {
        this.chartEntryHeaders.unshift({
          text: this.$t('labels.customerListName'),
          value: 'ListName',
          sortable: false,
          groupable: false,
          cellClass: ['regular-cell', 'bold-cell'],
          align: 'center',
        });
      }
    },

    /**
     * Get search history from service.
     */
    getHistory() {
      this.$store.state.loadingStatus = true;
      ExpressCargoServices.getPriceList({
        page: this.page,
        pageSize: this.itemsPerPage,
        PortalUser: this.filters.searchText,
        GetForCustomer: !this.isSupplier,
        IntegrationLogistic: this.filters.subsupplier,
        ExportImportType: this.filters.exportImportType,
        ListName: this.listName,
        PriceListStatus: this.filters.priceListStatus,
      })
        .then((response) => {
          this.items = response.data.Result;
          this.totalItems = response.data.TotalItems;
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Get integrated logistic companies.
     */
    getCompanyLogistics() {
      this.$store.state.loadingStatus = true;
      IntegrationService.getCompanyLogistics()
        .then((response) => {
          this.portalTypes = response.data.Result;
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Get portal users for current supplier.
     */
    getPortalUsers() {
      this.$store.state.loadingStatus = true;
      PortalService.getPortalUsers()
        .then((response) => {
          this.portalUsers = response.data.Result.PortalCompanies;
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Triggers when portal type is changed.
     * After trigger two new fields are added respectively to the selected portal type
     */
    portalTypeChanged() {
      if (this.form.IntegrationLogistic) {
        this.getIntegrationServices(this.form.IntegrationLogistic);
        this.getIntegrationPackages(this.form.IntegrationLogistic);
        this.getAccounts(this.form.IntegrationLogistic);
      }
    },
    getAccounts(logisticId) {
      this.$store.state.loadingStatus = true;
      IntegrationService.getAccounts(logisticId)
        .then((response) => {
          this.accounts = response.data.Result;
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getIntegrationServices(type) {
      this.$store.state.loadingStatus = true;
      PortalService.getIntegrationServices(type)
        .then((response) => {
          this.integrationServices = response.data.Result;
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    getIntegrationPackages(type) {
      this.$store.state.loadingStatus = true;
      PortalService.getIntegrationPackages(type)
        .then((response) => {
          this.integrationPackages = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Get FSC groups from service.
     */
    getFscGroups() {
      this.$store.state.loadingStatus = true;
      AdditionalCostsServices.getFscGroups()
        .then((response) => {
          this.fscGroups = response.data.Result;
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    resetModal() {
      this.$refs.addChartEntryObserver.reset();
      this.form = {
        name: '',
        cargo: '',
        country: '',
        currency: '',
        fscGroupId: null,
        regionsFile: null,
        pricesFile: null,
        exportImportType: 1,
        expiryDate: new Date().toISOString().slice(0, 10),
        portalUserIds: [],
        IntegrationLogistic: null,
        IntegrationLogisticId: null,
        IntegrationService: null,
      };
      this.addChartEntryModal = false;
    },

    /**
     * This will trigger a function on service error.
     * @param {Function} special
     * @param {*} error
     */
    onServiceError(error, special = null) {
      if (special) {
        special(error);
      } else {
        window.showError(error);
        this.pageLoading = false;
        this.$store.state.loadingStatus = false;
      }
    },
  },
};
</script>
<style>
.container {
  margin-top: 38px;
}
.offerFormSheet {
  padding: 30px;
}

.activeRadioButton {
  color: var(--pink) !important;
}

.color-pink {
  color: var(--pink) !important;
  font-weight: bold;
}

.bold-cell {
  font-weight: bold;
}

.regular-cell {
  color: #575454;
}
</style>
